<template>
  <div v-if="value">
    <component
      :is="c"
      v-if="c"
      v-bind="props"
      v-on="Object.assign({}, on, $listeners)"
    />

    <span v-else-if="valueKey == 'year'">
      {{
        $t(["common:foryear.text", "For year: {\{ year }\}"], { year: value })
      }}
    </span>
    <span v-else-if="valueKey == 'validFrom' || valueKey == 'valid_from'">
      {{ $t("common:validFrom.label", "Valid from") }} {{ $dayjs.date(value) }}
    </span>
  </div>
</template>
<script>
import AppShowOrganisationName from "@AppShows/organisation/AppShowOrganisationName.vue";
import AppShowPersonName from "@AppShows/person/AppShowPersonName.vue";
import AppShowDisciplineName from "@AppShows/AppShowDisciplineName.vue";
import { camelCase } from "lodash-es";
export default {
  name: "InputSkeleton",
  components: {
    AppShowPersonName,
    AppShowOrganisationName,
    AppShowDisciplineName
  },
  props: {
    valueKey: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: null
    },
    on: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      c: null,
      props: {}
    };
  },
  created() {
    if (this.value) {
      switch (camelCase(this.valueKey)) {
        case "personId":
          this.props.person = this.value;
          this.c = "AppShowPersonName";
          break;
        case "licenceCategoryId":
          break;
        case "disciplineId":
          this.props.id = this.value;
          this.c = "AppShowDisciplineName";
          break;
        case "clubId":
          this.props.organisation = this.value;
          this.c = "AppShowOrganisationName";
          break;
      }
    }
  }
};
</script>
